import type { FormEvent } from "react"

export const preventDefault =
  (func: (e: FormEvent) => void) => (event: FormEvent) => {
    event.preventDefault()
    return func(event)
  }
